(function () {
  "use strict";

  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    const amount = (cents / 100).toFixed(2);
    return amount + " zł";
  }

  function initBundle(widget) {
    if (widget.dataset.bundleReady === "true") return;
    widget.dataset.bundleReady = "true";

    const items = widget.querySelectorAll("[data-bundle-item]");
    const totalPriceEl = widget.querySelector("[data-bundle-total-price]");
    const submitBtn = widget.querySelector("[data-bundle-submit]");

    if (!items.length || !totalPriceEl || !submitBtn) return;

    const bundleVariantsData = widget.getAttribute("data-bundle-variants");
    let bundleVariants = null;
    try {
      if (bundleVariantsData) bundleVariants = JSON.parse(bundleVariantsData);
    } catch (e) {
      console.error("Failed to parse bundle variants JSON", e);
    }

    let isFullBundleSelected = false;
    let selectedBundleVariant = null;

    function calculateTotal() {
      let total = 0;
      let allChecked = true;

      items.forEach((item) => {
        const checkbox = item.querySelector("[data-bundle-checkbox]");
        const variantInput = item.querySelector("[data-bundle-variant-input]");

        if (checkbox && !checkbox.checked) {
          allChecked = false;
        }

        if (variantInput && (!checkbox || checkbox.checked)) {
          const price = parseInt(variantInput.getAttribute("data-price")) || 0;
          total += price;
        }
      });

      if (allChecked && bundleVariants && bundleVariants.length > 0) {
        isFullBundleSelected = true;

        const selectedOptionValues = [];
        widget
          .querySelectorAll("[data-bundle-variant-select]")
          .forEach((select) => {
            selectedOptionValues.push(
              select.options[select.selectedIndex].text.trim(),
            );
          });

        if (bundleVariants.length === 1) {
          selectedBundleVariant = bundleVariants[0];
        } else {
          selectedBundleVariant = bundleVariants.find((v) => {
            return v.options.every((opt) => selectedOptionValues.includes(opt));
          });
          if (!selectedBundleVariant) {
            selectedBundleVariant = bundleVariants[0];
          }
        }

        if (selectedBundleVariant && selectedBundleVariant.available) {
          const savings = total - selectedBundleVariant.price;
          totalPriceEl.textContent = "";

          const priceRow = document.createElement("div");
          priceRow.className = "tuya-product-bundle__price-row";

          const comparePriceSpan = document.createElement("span");
          comparePriceSpan.className = "tuya-product-bundle__compare-price";
          comparePriceSpan.textContent = formatMoney(total);

          const actualPriceSpan = document.createElement("span");
          actualPriceSpan.className = "tuya-product-bundle__actual-price";
          actualPriceSpan.textContent = formatMoney(selectedBundleVariant.price);

          priceRow.appendChild(comparePriceSpan);
          priceRow.appendChild(actualPriceSpan);
          totalPriceEl.appendChild(priceRow);

          if (savings > 0) {
            const template = widget.getAttribute("data-savings-text-template") || "";
            const savingsText = template.replace(
              "[savings]",
              formatMoney(savings),
            );
            const savingsRow = document.createElement("div");
            savingsRow.className = "tuya-product-bundle__savings-row";
            savingsRow.textContent = savingsText;
            totalPriceEl.appendChild(savingsRow);
          }
          return;
        }
      }

      isFullBundleSelected = false;
      selectedBundleVariant = null;
      totalPriceEl.textContent = "";

      const priceRow = document.createElement("div");
      priceRow.className = "tuya-product-bundle__price-row";

      const actualPriceSpan = document.createElement("span");
      actualPriceSpan.className = "tuya-product-bundle__actual-price";
      actualPriceSpan.textContent = formatMoney(total);

      priceRow.appendChild(actualPriceSpan);
      totalPriceEl.appendChild(priceRow);
    }

    items.forEach((item) => {
      const checkbox = item.querySelector("[data-bundle-checkbox]");
      const select = item.querySelector("[data-bundle-variant-select]");
      const variantInput = item.querySelector("[data-bundle-variant-input]");
      const priceDisplay = item.querySelector("[data-price-element]");

      if (checkbox) {
        checkbox.addEventListener("change", calculateTotal);
      }

      if (select && variantInput) {
        select.addEventListener("change", function () {
          const selectedOption = select.options[select.selectedIndex];
          const newId = selectedOption.value;
          const newPrice =
            parseInt(selectedOption.getAttribute("data-price")) || 0;

          variantInput.value = newId;
          variantInput.setAttribute("data-price", newPrice);

          if (priceDisplay) {
            priceDisplay.textContent = formatMoney(newPrice);
            priceDisplay.setAttribute("data-price-element", newPrice);
          }

          calculateTotal();
        });
      }
    });

    if (submitBtn) {
      submitBtn.addEventListener("click", function (e) {
        e.preventDefault();

        const individualVariantIds = [];
        const checkedVariantIds = [];
        const uncheckedVariantIds = [];

        items.forEach((item) => {
          const checkbox = item.querySelector("[data-bundle-checkbox]");
          const variantInput = item.querySelector(
            "[data-bundle-variant-input]",
          );
          if (variantInput && variantInput.value) {
            const vId = parseInt(variantInput.value);
            individualVariantIds.push(vId);
            if (!checkbox || checkbox.checked) {
              checkedVariantIds.push(vId);
            } else {
              uncheckedVariantIds.push(vId);
            }
          }
        });

        let toAdd = [];
        let toRemove = [];
        const bundleVariantIds = bundleVariants
          ? bundleVariants.map((v) => parseInt(v.id))
          : [];

        if (isFullBundleSelected && selectedBundleVariant) {
          toAdd = [parseInt(selectedBundleVariant.id)];
          toRemove = [
            ...individualVariantIds,
            ...bundleVariantIds.filter(
              (id) => id !== parseInt(selectedBundleVariant.id),
            ),
          ];
        } else {
          toAdd = checkedVariantIds;
          toRemove = [...bundleVariantIds, ...uncheckedVariantIds];
        }

        if (toAdd.length === 0) return;

        const textAdding = submitBtn.getAttribute("data-text-adding");
        const textAdded = submitBtn.getAttribute("data-text-added");
        const textError = submitBtn.getAttribute("data-text-error");

        submitBtn.disabled = true;
        const originalText = submitBtn.innerHTML;
        submitBtn.innerHTML = textAdding;

        fetch("/cart.js")
          .then((res) => {
            if (!res.ok) throw new Error("Failed to fetch cart");
            return res.json();
          })
          .then((cart) => {
            const variantIdsInCart = cart.items.map((item) => item.id);

            const updates = {};
            toRemove.forEach((id) => {
              if (variantIdsInCart.includes(id)) {
                updates[id] = 0;
              }
            });

            const filteredToAdd = toAdd.filter(
              (id) => !variantIdsInCart.includes(id),
            );

            const removalPromise =
              Object.keys(updates).length > 0
                ? fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({ updates }),
                  }).then((res) => {
                    if (!res.ok) throw new Error("Failed to update");
                  })
                : Promise.resolve();

            return removalPromise
              .then(() => {
                if (filteredToAdd.length === 0) return;
                return fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    items: filteredToAdd.map((id) => ({ id, quantity: 1 })),
                  }),
                }).then((res) => {
                  if (!res.ok) throw new Error("Failed to add");
                });
              })
              .then(() =>
                fetch("/cart.js").then((res) => {
                  if (!res.ok) throw new Error("Failed to fetch final cart");
                  return res.json();
                }),
              );
          })
          .then((cart) => {
            submitBtn.innerHTML = textAdded;

            const event = new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: cart,
                action: "add",
                data: { source: "product-bundle-component" },
              },
            });
            document.dispatchEvent(event);

            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer && typeof cartDrawer.open === "function") {
              cartDrawer.open();
            } else {
              const drawerBtn = document.querySelector(
                ".header-actions__cart-icon, [data-cart-drawer-trigger]",
              );
              if (drawerBtn) drawerBtn.click();
            }

            setTimeout(() => {
              submitBtn.innerHTML = originalText;
              submitBtn.disabled = false;
            }, 1500);
          })
          .catch((error) => {
            console.error("Error syncing cart bundle:", error);
            submitBtn.innerHTML = textError;
            setTimeout(() => {
              submitBtn.innerHTML = originalText;
              submitBtn.disabled = false;
            }, 1500);
          });
      });
    }

    calculateTotal();
  }

  function initAllBundles() {
    document.querySelectorAll("[data-tuya-bundle]").forEach(initBundle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllBundles);
  } else {
    initAllBundles();
  }

  document.addEventListener("shopify:section:load", function (event) {
    const sectionBundles = event.target.querySelectorAll("[data-tuya-bundle]");
    sectionBundles.forEach(initBundle);
  });
})();
